// import React, { useEffect, useState, useContext } from 'react';
// import PositionCard from './../components/PositionCard';
// import { WebSocketContext } from "../WebSocketContext";
// import config from '../config'; // Assuming you have a config file with API_BASE_URL
// import '../Portfolio.css'; // Assuming you will style the portfolio page

// const Portfolio = ({ user_id }) => {
//   const [positions, setPositions] = useState([]);
//   const [userDetails, setUserDetails] = useState([]);
//   const { stocks, lastUpdateTime } = useContext(WebSocketContext);

//   useEffect(() => {
//     const fetchPositions = async () => {
//       try {
//         const response = await fetch(`${config.API_BASE_URL}portfolio`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({ user_id }),
//         });
//         const data = await response.json();
//         // Assuming data is an array of positions
//         setPositions(data);
//       } catch (error) {
//         console.error('Error fetching portfolio positions:', error);
//       }
//     };

//     const fetchUserDetails = async () => {
//       try {
//         const response = await fetch(`${config.API_BASE_URL}getUserDetails`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer 7c85cfc0ad2328331d4784ffedb97565154cd2016ed0b2b6843a53e7f2a2343d`
//           },
//           body: JSON.stringify({ user_id }),
//         });
//         const data = await response.json();
//         // Assuming data is an array of positions
//         setUserDetails(data);
//       } catch (error) {
//         console.error('Error fetching user details:', error);
//       }
//     };

//     fetchUserDetails();
//     fetchPositions();
//   }, [user_id]);

//   return (
//     <div className="portfolio-page">
//       {/* <div className="position-list"> */}
//         {positions.map(position => (
//           <PositionCard stock={stocks[position.tradingsymbol]} userDetails={userDetails} key={position.orderId} position={position} />
//         ))}
//       {/* </div> */}
//     </div>
//   );
// }

// export default Portfolio;


// import React, { useEffect, useState, useContext } from 'react';
// import PositionCard from './../components/PositionCard';
// import { WebSocketContext } from "../WebSocketContext";
// import config from '../config'; // Assuming you have a config file with API_BASE_URL
// import '../Portfolio.css'; // Assuming you will style the portfolio page

// const Portfolio = ({ user_id }) => {
//   const [positions, setPositions] = useState([]);
//   const [userDetails, setUserDetails] = useState({});
//   const { stocks, lastUpdateTime } = useContext(WebSocketContext);

//   useEffect(() => {
//     const fetchPositions = async () => {
//       try {
//         const response = await fetch(`${config.API_BASE_URL}portfolio`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({ user_id }),
//         });
//         const data = await response.json();
//         setPositions(data); // Assuming data is an array of positions
//       } catch (error) {
//         console.error('Error fetching portfolio positions:', error);
//       }
//     };

//     const fetchUserDetails = async () => {
//       try {
//         const response = await fetch(`${config.API_BASE_URL}getUserDetails`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer 7c85cfc0ad2328331d4784ffedb97565154cd2016ed0b2b6843a53e7f2a2343d` // Ensure this is stored securely
//           },
//           body: JSON.stringify({ user_id }),
//         });
//         const data = await response.json();
//         setUserDetails(data); // Assuming data is an object of user details
//       } catch (error) {
//         console.error('Error fetching user details:', error);
//       }
//     };

//     fetchUserDetails();
//     fetchPositions();
//   }, [user_id]);

//   return (
//     <div className="portfolio-page">
//       {positions.length > 0 && Object.keys(userDetails).length > 0 ? (
//         positions.map(position => {
//           const stock = stocks[position.tradingsymbol] || {}; // Provide a default value if undefined
//           return (
//             <PositionCard 
//               key={position.orderId} 
//               stock={stock} 
//               userDetails={userDetails} 
//               position={position} 
//             />
//           );
//         })
//       ) : (
//         <p>Loading positions...</p>
//       )}
//     </div>
//   );
// }

// export default Portfolio;


// import React, { useEffect, useState, useContext } from 'react';
// import PositionCard from './../components/PositionCard';
// import { WebSocketContext } from "../WebSocketContext";
// import config from '../config'; // Assuming you have a config file with API_BASE_URL
// import '../Portfolio.css'; // Assuming you will style the portfolio page

// const Portfolio = ({ user_id }) => {
//   const [positions, setPositions] = useState([]);
//   const [userDetails, setUserDetails] = useState({});
//   const { stocks, lastUpdateTime } = useContext(WebSocketContext);

//   useEffect(() => {
//     const fetchPositions = async () => {
//       try {
//         const response = await fetch(`${config.API_BASE_URL}portfolio`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({ user_id }),
//         });
//         const data = await response.json();
//         setPositions(data); // Assuming data is an array of positions
//       } catch (error) {
//         console.error('Error fetching portfolio positions:', error);
//       }
//     };

//     const fetchUserDetails = async () => {
//       try {
//         const response = await fetch(`${config.API_BASE_URL}getUserDetails`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer 7c85cfc0ad2328331d4784ffedb97565154cd2016ed0b2b6843a53e7f2a2343d` // Ensure this is stored securely
//           },
//           body: JSON.stringify({ user_id }),
//         });
//         const data = await response.json();
//         setUserDetails(data); // Assuming data is an object of user details
//       } catch (error) {
//         console.error('Error fetching user details:', error);
//       }
//     };

//     fetchUserDetails();
//     fetchPositions();
//   }, [user_id]);

//   // Calculate total PnL
//   const calculateTotalPnL = () => {
//     return positions.reduce((total, position) => {
//       const stock = stocks[position.tradingsymbol] || {};
//       const pnl = calculatePnL(position, stock);
//       return total + pnl;
//     }, 0);
//   };

//   // Function to calculate PnL for each position
//   const calculatePnL = (position, stock) => {
//     if (position.buy_sell === "1") {
//       if (stock.Bid === 0) return 0;
//       else return (stock.Bid * position.orderQuantity) - (position.orderPrice * position.orderQuantity);
//     } else {
//       if (stock.Ask === 0) return 0;
//       else return (position.orderPrice * position.orderQuantity) - (stock.Ask * position.orderQuantity);
//     }
//   };

//   return (
//     <div className="portfolio-page">
//       <div className="total-pnl">
//         <h2>Total PnL: {calculateTotalPnL()}</h2>
//       </div>
//       {positions.length > 0 && Object.keys(userDetails).length > 0 ? (
//         positions.map(position => {
//           const stock = stocks[position.tradingsymbol] || {};
//           return (
//             <PositionCard 
//               key={position.orderId} 
//               stock={stock} 
//               userDetails={userDetails} 
//               position={position} 
//             />
//           );
//         })
//       ) : (
//         <p>Loading positions...</p>
//       )}
//     </div>
//   );
// }

// export default Portfolio;



import React, { useEffect, useState, useContext } from 'react';
import PositionCard from './../components/PositionCard';
import BottomSheetPortfolio from './../components/BottomSheetPortfolio';
import { WebSocketContext } from "../WebSocketContext";
import config from '../config'; // Assuming you have a config file with API_BASE_URL
import '../Portfolio.css'; // Assuming you will style the portfolio page
import { Refresh } from '@mui/icons-material';
import { checkAppSession } from '../utils/apiFetch';
import { markPriceAtCircuit } from '../utils/circuitMarkPrice';

const Portfolio = () => {
  //const [positions, setPositions] = useState([]);
  //const [userDetails, setUserDetails] = useState({});
  //const { stocks, lastUpdateTime } = useContext(WebSocketContext);
  const { trades, performance, positions = [], userScripts=[], stocks, userDetails, refreshTradesAndPortfolio } = useContext(WebSocketContext);
  const [showBottomSheet, setShowBottomSheet] = useState(false);
  const [selectedStock, setSelectedStock] = useState(null);
  const [isDetailsExpanded, setIsDetailsExpanded] = useState(false);
  let oldRates = [];
  let userScriptsTemp = [];

  const toggleDepth = () => {
    setIsDetailsExpanded(!isDetailsExpanded);
  };

  const handleCardClick = async (position) => {
    const sessionOk = await checkAppSession();
    if (!sessionOk) {
      return;
    }

    setSelectedStock(position);
    // if(stock.exchange=="OPTSTK"){
    //   stock.intraday = userDetails.OPTSTK_intraday;
    // } else if(stock.exchange=="FUTSTK"){
    //   stock.intraday = userDetails.FUTSTK_intraday;
    // } else if(stock.exchange=="FUTCOM"){
    //   stock.intraday = userDetails.FUTCOM_intraday;
    // }
    setShowBottomSheet(true);
  };

  const handleCloseSheet = () => {
    setShowBottomSheet(false);
    setSelectedStock(null);
    // alert("closed"+showBottomSheet);
  };

  // Function to get the latest stock data for the selected stock
  const getLatestStockData = (stock) => {
    return stocks[stock.instrument_token] || {};
  };

  

  // Effect to update the selected stock data in the bottom sheet whenever stocks context updates
  useEffect(() => {
    if (selectedStock && selectedStock.instrument_token) {
      const latestStockData = getLatestStockData(selectedStock);
      // Only update if the stock data actually changed to prevent infinite loop
      setSelectedStock((prevStock) => {
        // Check if the live data has actually changed
        const prevLiveData = prevStock?.live || {};
        const hasChanged = JSON.stringify(prevLiveData) !== JSON.stringify(latestStockData);
        
        if (hasChanged && prevStock?.instrument_token === selectedStock.instrument_token) {
          return {
            ...prevStock,
            live: latestStockData,
          };
        }
        return prevStock;
      });
    }
  }, [stocks]); // Removed selectedStock from dependencies to prevent infinite loop

  // Calculate total PnL
  const calculateTotalPnL = () => {
    return positions.reduce((total, position) => {
      //console.log("calc pnls : ",position);
      const stock = stocks[position.instrument_token] || {};
      const pnl = Number(calculatePnL(position, stock));
      var t =Number(Number(total) + pnl - Number(position.brokerage)).toFixed(2); 
      
      return t;
    }, 0);
  };

  const calculateBookedPnL = () => {

    if (!Array.isArray(performance)) {
      performance = [performance]; // Ensure it's an array
    }

    return performance.reduce((total, position) => {
      //const stock = stocks[position.instrument_token] || {};
      //console.log("calc pnl", position);
      const pnl = Number(position.closing_order.pnl);
      var t =Number(Number(total) + pnl - Number(position.brokerage) - Number(position.closing_order.brokerage)).toFixed(2); 
      
      return t;
    }, 0);
  };

  // Calculate total CF Margin (same logic as PositionCard calculateValue)
  const calculateTotalCFMargin = () => {
    const total = positions.reduce((sum, position) => {
      let cfMargin = 0;
      
      // Same calculation as in PositionCard component
      if (position.exchange === 'OPTSTK' && String(position.buy_sell) === "2") {
        cfMargin = Number(position.orderLotQuantity * userDetails.OPTSTK_balanceCF);
      } else {
        // Check for script_wise_margin for delivery/CF margin calculation
        if (position.exchange === "FUTCOM") {
          if (userDetails.FUTCOM_margin_type === "script_wise" && userDetails.script_wise_margin && userDetails.script_wise_margin[position.stockName]) {
            try {
              const scriptMarginData = JSON.parse(userDetails.script_wise_margin[position.stockName]);
              // Check if delivery field exists in script_wise_margin, otherwise use regular calculation
              if (scriptMarginData.delivery) {
                cfMargin = Number(position.orderLotQuantity * scriptMarginData.delivery);
              } else {
                // Fallback to regular delivery calculation
                const deliveryKey = `${position.exchange}_delivery`;
                if (userDetails[deliveryKey] && userDetails[deliveryKey] > 0) {
                  cfMargin = Number((position.orderQuantity * position.orderPrice) / userDetails[deliveryKey]);
                }
              }
            } catch (error) {
              console.error("Error parsing script_wise_margin for FUTCOM:", error);
              // Fallback to regular delivery calculation
              const deliveryKey = `${position.exchange}_delivery`;
              if (userDetails[deliveryKey] && userDetails[deliveryKey] > 0) {
                cfMargin = Number((position.orderQuantity * position.orderPrice) / userDetails[deliveryKey]);
              }
            }
          } else {
            // Fallback to regular delivery calculation
            const deliveryKey = `${position.exchange}_delivery`;
            // console.log("deliveryKey", deliveryKey);
            if (userDetails[deliveryKey] && userDetails[deliveryKey] > 0) {
              // console.log("userDetails[deliveryKey]", userDetails[deliveryKey]);
              cfMargin = Number((position.orderQuantity * position.orderPrice) / userDetails[deliveryKey]);
              // console.log("cfMargin", cfMargin);
            }
          }
        } else if (position.exchange === "FUTSTK") {
          const futstkScripts = ['NIFTY', 'BANKNIFTY', 'FINNIFTY', 'MIDCPNIFTY'];
          if (userDetails.FUTSTK_margin_type === "script_wise" && futstkScripts.includes(position.stockName) && userDetails.script_wise_margin && userDetails.script_wise_margin[position.stockName]) {
            try {
              const scriptMarginData = JSON.parse(userDetails.script_wise_margin[position.stockName]);
              // Check if delivery field exists in script_wise_margin, otherwise use regular calculation
              if (scriptMarginData.delivery) {
                cfMargin = Number(position.orderLotQuantity * scriptMarginData.delivery);
              } else {
                // Fallback to regular delivery calculation
                const deliveryKey = `${position.exchange}_delivery`;
                if (userDetails[deliveryKey] && userDetails[deliveryKey] > 0) {
                  cfMargin = Number((position.orderQuantity * position.orderPrice) / userDetails[deliveryKey]);
                }
              }
            } catch (error) {
              console.error("Error parsing script_wise_margin for FUTSTK:", error);
              // Fallback to regular delivery calculation
              const deliveryKey = `${position.exchange}_delivery`;
              if (userDetails[deliveryKey] && userDetails[deliveryKey] > 0) {
                cfMargin = Number((position.orderQuantity * position.orderPrice) / userDetails[deliveryKey]);
              }
            }
          } else {
            // Fallback to regular delivery calculation
            const deliveryKey = `${position.exchange}_delivery`;
            if (userDetails[deliveryKey] && userDetails[deliveryKey] > 0) {
              cfMargin = Number((position.orderQuantity * position.orderPrice) / userDetails[deliveryKey]);
            }
          }
        } else {
          // For other exchanges, use regular delivery calculation
          const deliveryKey = `${position.exchange}_delivery`;
          if (userDetails[deliveryKey] && userDetails[deliveryKey] > 0) {
            cfMargin = Number((position.orderQuantity * position.orderPrice) / userDetails[deliveryKey]);
          }
        }
      }
      
      return Number(sum) + cfMargin;
    }, 0);
    
    return Number(total).toFixed(2);
  };

  // const calculateTotalPnl = () => {
  //   return Number( Number(calculatePnL()) + Number(calculateBookedPnL()) ).toFixed(2);
  // };

  // Function to calculate PnL for each position
  const calculatePnL = (position, stock) => {
    const ltp = stock.LTP != undefined ? stock.LTP : position.lastTradedPrice;
    if (String(position.buy_sell) === "1") {
      if(stock.Bid==undefined) stock.Bid = position.buyPrice;
      const bid = markPriceAtCircuit(stock.Bid, ltp, position.lower_circuit, position.upper_circuit);
      if (bid === undefined){ 
        //console.log(stock.stockName, stock.Bid);
        return 0;
      }
      else
      { 
        //console.log(stock.stockName, stock.Bid);
        return (bid * position.orderQuantity) - (position.orderPrice * position.orderQuantity);
      }
    } 
    else 
    {
      if(stock.Ask==undefined) stock.Ask = position.sellPrice;
      const ask = markPriceAtCircuit(stock.Ask, ltp, position.lower_circuit, position.upper_circuit);
      if (ask === undefined){ 
        //console.log(stock.stockName, stock.Ask);
        return 0;
      }
      else
      {
          //console.log(stock.stockName, stock.Ask);
         return (position.orderPrice * position.orderQuantity) - (ask * position.orderQuantity);
      }
    }
  };

  const handleRefresh = () => {
    refreshTradesAndPortfolio("both");
  };

  // Function to check if there is a matching pending trade for a position
  const hasMatchingPendingTrade = (position) => {
    if (!position.stockId) return false;
    
    return trades.some(trade => 
      trade.orderStatus == "1" && 
      trade.stockId == position.stockId &&
      trade.associatedOrderId == position.orderId
    );
  };

  return (
    <div className="portfolio-page">
      {/* <div className="total-pnl">
        <h2>Total PnL: {calculateTotalPnL()}</h2>
      </div> */}
      <button className="refresh-button" onClick={handleRefresh}><Refresh /></button>
      {/* <div className="pnl-display">
        <span className="pnl-title">Total P&L </span>
        <span className={`pnl-value ${calculateTotalPnL() < 0 ? 'negative' : 'positive'}`}>
        ₹{calculateTotalPnL()}
        </span>
      </div> */}

      <div  className="pnl-display" onClick={toggleDepth} style={{display:'flex', padding:'0px'}}>
        <div className="pnl-display" style={{display:'block', margin:'0px'}}>
          <span className="pnl-title">Current P&L </span>
          <p className={`pnl-value ${calculateTotalPnL() < 0 ? 'negative' : 'positive'}`}>
          ₹{calculateTotalPnL()}
          </p>
        </div>
        <div className="pnl-display" style={{display:'block', margin:'0px', textAlign:'center'}}>
          <span className="pnl-title">Booked P&L </span>
          <p className={`pnl-value ${calculateBookedPnL() < 0 ? 'negative' : 'positive'}`}>
          ₹{calculateBookedPnL()}
          </p>
        </div>
        <div className="pnl-display" style={{display:'block', margin:'0px', textAlign:'right'}}>
          <span className="pnl-title">Net P&L </span>
          <p className={`pnl-value ${ (Number(calculateBookedPnL())+Number(calculateTotalPnL())) < 0 ? 'negative' : 'positive'}`}>
          ₹{ Number(Number(calculateBookedPnL()) +Number(calculateTotalPnL())).toFixed(2)}
          </p>
        </div>
        
      </div>

      {positions.length > 0 && Object.keys(userDetails).length > 0 ? (
        positions.map(position => {
          const stock = stocks[position.instrument_token] || {};
          const hasPendingTrade = hasMatchingPendingTrade(position);
          //console.log(position);
          return (
            <PositionCard 
              key={position.orderId} 
              stock={stock} 
              userDetails={userDetails} 
              position={position} 
              onCardClick={handleCardClick}
              isMLMClient = {false}
              hasPendingTrade={hasPendingTrade}
            />
          );
        })
      ) : (
        <div className="net-pos-empty-state">
          {/* <h3>0 Positions</h3> */}
          <p>You don't have any positions at the moment.</p>
        </div>
      )}

      {/* Compact Total CF Margin display below the list */}
      {positions.length > 0 && Object.keys(userDetails).length > 0 && (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '12px 16px',
          marginTop: '10px',
          marginBottom: '10px',
          backgroundColor: '#f5f5f5',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: '500'
        }}>
          <span style={{ color: '#666', marginRight: '8px' }}>Total CF Margin:</span>
          <span style={{ color: '#333', fontWeight: 'bold' }}>{calculateTotalCFMargin()}</span>
        </div>
      )}

      {selectedStock && <BottomSheetPortfolio isOpen={showBottomSheet} onClose={handleCloseSheet} userDetails={userDetails} position={selectedStock} />}
    </div>
  );
}

export default Portfolio;

